export function isMobileOrTablet() {
  const ua = navigator.userAgent || "";

  // User-Agent Client Hints
  if (navigator.userAgentData?.mobile) {
    return true;
  }

  // Tablets etc.
  if (/SM-X|SM-T|SM-P|Tab[0-9]|Pad[0-9]/i.test(ua)) {
    return true;
  }

  // Standard Mobile/Tablet detection (Regex)
  const isBasicMobile =
    /iPhone|iPod|iPad|BlackBerry|IEMobile|Opera Mini/i.test(ua) ||
    (/Android/i.test(ua) && /Mobile/i.test(ua));
  const isAndroidTablet = /Android/i.test(ua) && !/Mobile/i.test(ua);
  if (isBasicMobile || isAndroidTablet) return true;

  // Desktop Mode Detection
  const hasMultiTouch = navigator.maxTouchPoints > 1;
  if (hasMultiTouch) {
    // Screen width check: Most tablets (including iPad Pro 12.9)
    // fall under 1366px in their logical width.
    // Large monitors (iMac, Desktop) will be much higher.
    const screenWidth = window.screen.width || 0;
    const isTabletSized = screenWidth <= 1366;

    // iPad detection (iPadOS 13+ claims to be Macintosh)
    if (/Macintosh/i.test(ua) && isTabletSized) return true;

    // Android/Samsung in Desktop Mode (claims to be Linux/X11)
    if (/Linux|X11/i.test(ua) && !/Ubuntu|Fedora|Arch|Debian/i.test(ua)) {
      return true;
    }
  }

  // Tablet keyword fallback
  if (/Tablet|Tab(?!let)|Pad|Kindle|Silk|PlayBook/i.test(ua)) {
    return true;
  }

  // Windows tablets (Surface) - Usually have "Touch" and are small
  if (/Windows NT.*Touch/i.test(ua) && window.screen.width <= 1366) return true;

  return false;
}
